import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CoacheeProfileInformationActivitiesController } from 'presentation/page/profile/coachee-profile/coachee-profile-information/coachee-profile-information-activities/coachee-profile-information-activities.controller';

@Component({
	selector: 'spr-coachee-profile-information-activities',
	templateUrl: './coachee-profile-information-activities.component.html',
	providers: [CoacheeProfileInformationActivitiesController],
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class: 'flex relative',
	},
})
export class CoacheeProfileInformationActivitiesComponent {
	constructor(
		public controller: CoacheeProfileInformationActivitiesController
	) {}
}
